import { registerEnumType } from 'type-graphql'

export enum ScanBatchStatusEnum {
  Queued = 'queued',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

registerEnumType(ScanBatchStatusEnum, {
  name: 'ScanBatchStatusEnum',
  description: 'Lifecycle status of a multi-image batch scan job',
})
